/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Accueil',
	myContent: 'Mon contenu',
	teamContent: 'Contenu de l\'équipe',
	folder: 'Dossier',
	files: 'Fichiers',
	actionMenu: 'Menu Action',
	myFolder: 'Mes dossiers',

	emptyFolderNoContent: 'Aucun contenu',

	//EmptyStates
	emptyRecentTitle: 'Vous n\'avez affiché aucun contenu récemment.',
	emptyStateTitle: 'Commencez par ajouter des données',
	emptyStateBody: 'Cliquez sur Transférer les données ci-dessus ou glissez-déposez pour transférer les données.',
	emptySearchResultTitle: 'Votre recherche n\'a renvoyé aucun résultat.',
	emptyPortalTitle: 'Aucun portail',
	emptyPortalBody: 'Vous n\'avez actuellement pas de portail.',
	emptyWsProjectTitle: 'Commencez par créer un bloc-notes dans Watson Studio.',
	emptyWsProjectBody: 'Lorsque vous retournerez dans Cognos Analytics, votre bloc-notes apparaîtra ici.',
	emptyFilteredResultTitle: 'Les filtres appliqués n\'ont renvoyé aucun résultat.',
	emptyDialogViewTitle: 'Aucun élément',
	removeFromRecents: 'Retirer des éléments récents',

	// Welcome Banner
	welcomeBannerGreeting: 'Bonjour. Bienvenue dans Cognos Analytics.',
	welcomeBannerDescription: 'Cognos Analytics permet aux utilisateurs d\'effectuer des analyses en libre-service basées sur l\'intelligence artificielle. Découvrez comment la préparation automatisée de données, la reconnaissance de données et les visualisations peuvent aboutir à des décisions plus sûres.',
	welcomeBannerDescription_trialUser: 'Vous pouvez commencer à utiliser immédiatement le produit en visionnant notre vidéo de présentation, en effectuant la visite guidée du produit et en affichant l\'onglet Mise en route.',
	takeTourButtonLabel: 'Effectuer une visite guidée du produit',
	watchVideoButtonLabel: 'Visionner la vidéo',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Voulez-vous vraiment désactiver la bannière de bienvenue de votre page d\'accueil ? Vous pouvez la réactiver à tout moment dans Profil et paramètres > Paramètres > Général. ',
	hideWelcomeBannerTitle: 'Désactiver la bannière de bienvenue',
	ok: 'OK',
	cancel: 'Annuler',
	//howto video dialog
	modal_how_title: 'Vidéos explicatives',
	modal_overview_title: 'Visionner une présentation de Cognos Analytics',
	modal_how_play: 'Lire la vidéo',
	modal_how_video_title_overview: 'Aperçu',
	modal_how_video_title_getStarted: 'Initiation à la version 11.2',
	modal_how_video_title_newUI: 'Bienvenue dans la nouvelle expérience Cognos',
	modal_how_video_title_dataModule: 'Présentation des modules de données',
	modal_how_video_title_explore: 'Présentation de l\'exploration de données',
	modal_how_video_title_dashboard: 'Présentation des tableaux de bord interactifs',
	modal_how_video_title_reporting: 'Présentation de la génération de rapports',
	modal_how_video_title_mobile: 'La puissance de Cognos au creux de votre main',

	// Toolbar
	search: 'Rechercher',
	addFolder: 'Ajouter un dossier',
	addLink: 'Ajouter un lien',
	filter: 'Filtre',
	sort: 'Trier',
	settings: 'Paramètres',
	tilesView: 'Vue Mosaïque',
	listView: 'Vue de liste',
	columnView: 'Vue Colonne',

	// Toolbar Actions
	sortBy: 'Trier par',
	sortOrder: 'Ordonner',
	name: 'Nom',
	modifiedTime: 'Modifié',
	type: 'Type',
	ascending: 'Croissant',
	descending: 'Décroissant',

	filterType: 'Type',
	filterModificationTime: 'Modifié',
	all: 'Toutes',
	today: 'Aujourd\'hui',
	yesterday: 'Hier',
	pastWeek: 'Semaine dernière',
	pastMonth: 'Mois dernier',
	resetFilters: 'Réinitialiser les filtres',

	filterSearchPlaceHolder: 'Filtrer par mots clés',

	resetFilterTag: 'Cliquez sur X pour réinitialiser les filtres.',
	filterTagToolTip: 'Filtres appliqués : %{appliedFilters}.',

	folderName: 'Nom du dossier',
	addAFolder: 'Ajouter un dossier',
	add: 'Ajouter',
	error: 'Erreur',
	newFolderDefaultName: 'Nouveau dossier',
	toastCreateNewFolder: 'Le dossier %{nameOfFolder} a été créé dans %{tabName}.',
	folderAdded: 'Dossier ajouté',
	refresh: 'Actualiser',
	openFolder: 'Ouvrir le dossier',

	addAUrl: 'Ajouter une URL',
	linkName: 'Nom de l\'URL',
	linkNamePlaceholder: 'Ajouter un nom d\'URL',
	linkDescription: 'Description (facultatif)',
	linkDescriptionPlaceholder: 'Ajouter une description',
	linkUri: 'URL',
	linkUriPlaceholder: 'Ajouter une URL qui utilise un domaine acceptable',
	acceptableDomains: 'Domaines acceptables',
	viewAcceptableDomains: 'Afficher les domaines acceptables',
	mandatoryField: 'Zone obligatoire',
	linkAdded: 'URL ajoutée',
	toastCreateNewLink: '%{nameOfLink} a été ajouté à %{tabName}.',
	noEntries: 'La liste de domaines acceptables ne comporte aucune entrée. Veuillez contacter l\'administrateur.',

	compact: 'Compact',
	short: 'Abrégé',
	default: 'Par défaut',
	rowSize: 'Taille de ligne',

	// GroupyByTypes
	folders: 'Dossiers',
	reports: 'Rapports',
	dashboards: 'Tableaux de bord',
	data: 'Données',
	packages: 'Packs',
	explorations: 'Explorations',
	stories: 'Histoires',
	notebooks: 'Blocs-notes',
	others: 'Autre',

	// Error Messages
	itemsOverLimit: 'Le nom indiqué "%{itemName}" a dépassé la limite maximale (20). Indiquez un nom différent pour continuer.',
	errorMessageLengthFolderName: 'Entrez un nom de dossier qui ne dépasse pas 255 caractères.',
	errorMessageLengthLinkName: 'Entrez un nom de lien qui ne dépasse pas 255 caractères.',
	toastLaunchPerspectiveError: 'Impossible d\'ouvrir %{objectType}.',
	errorNoAccessTitle: 'Hmm, il semblerait que vous n\'ayez pas accès à ce contenu',
	errorNoAccessBody: 'Contactez votre administrateur ou reportez-vous au lien suivant :',
	errorEnableExternalContent: 'Activation du contenu externe',

	//TableHeader
	lastModified: 'Dernière modification',
	location: 'Emplacement',
	tenant: 'Locataire',

	// GetStartedTab
	getStartedLabel: 'Etre opérationnel dans IBM Cognos Analytics',
	learningHowToLabel: 'Ressources d\'apprentissage',
	learningHowToDescription: 'Développez vos connaissances et obtenez de l\'aide en rejoignant la communauté, en lisant les documentations et en visionnant des vidéos.',
	learningHowToActionLabel: 'Lancer le panneau d\'apprentissage',
	howToVideosLabel: 'Vidéos tutoriels',
	howToVideosDescription: 'Apprenez à utiliser IBM Cognos Analytics et commencez à mieux comprendre vos données.',
	howToVideosActionLabel: 'Visionner des vidéos',
	acceleratorCatalogLabel: 'Catalogue d\'accélérateurs',
	acceleratorCatalogDescription: 'Parcourez un catalogue régulièrement enrichi qui présente des utilisations dans des secteurs d\'activité, des guides des meilleures pratiques, des visualisations personnalisées, etc.',
	acceleratorCatalogActionLabel: 'Parcourir le catalogue',
	sampleSectionTitle: 'Exemples',
	sampleSectionDescription: 'Découvrez des exemples qui présentent tout ce que Cognos Analytics peut offrir.',
	// Samples Section
	createDashboardSampleTitle: 'Comment créer votre premier tableau de bord',
	createDashboardSampleDescription: 'Découvrez l\'analyse avec Cognos Dashboards.',
	covid19SampleTitle: 'Tableau de bord COVID',
	covid19SampleDescription: 'Explorez le champ des possibles avec ce tableau de bord Cognos qui analyse des données relatives au virus COVID-19 et les extensions personnalisées.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Développez votre bibliothèque de visualisations avec des visualisations personnalisées, telles que le graphique Sankey.',
	viewAllSamplesActionLabel: 'Afficher tous les exemples',
	byFeatureTitle: 'Par fonction',
	byFeatureDescription: 'Parcourir les exemples par fonction, comme la fonctionnalité de base, les contrôles personnalisés, les extensions, les blocs-notes et les dates relatives.',
	byIndustryTitle: 'Par secteur',
	byIndustryDescription: 'Parcourir les exemples par secteur, comme l\'automobile, la banque, etc.',
	// SamplesTab
	sampleTabTitle: 'Laissez-vous inspirer par nos exemples préconfigurés',
	sampleTabLabel: 'Pour plus d\'exemples et d\'extensions d\'IBM, de partenaires et de clients, rendez-vous dans le catalogue d\'accélérateurs',

	// quickLaunch
	quickLaunchLabel: 'Lancement rapide',
	expand: 'Développer',
	collapse: 'Réduire',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Commencez par choisir ce que vous souhaitez créer.',

	// contentPageView
	contentPageTitleLabel: 'Contenu',
	uploadFile: 'Transférer les données',
	new: 'Nouveau',
	create: 'Créer',
	more: 'Plus',

	// open dialog
	selectDataSourcesToAdd: 'Sélectionnez une ou plusieurs sources de données à ajouter.',
	openDialogDefaultTitle: 'Ouvrir',

	// save dialog
	save: 'Sauvegarder',
	saveAs: 'Sauvegarder sous',
	saving: 'Sauvegarde...',
	selectedDestination: 'Destination sélectionnée : %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' existe déjà avec un type différent. Veuillez choisir un autre nom.',
	confirmOverwriteTitle: 'Confirmer le remplacement des données existantes',
	confirmOverwriteMsg: 'Le fichier \'%{nameOfFile}\' existe déjà. Voulez-vous remplacer ses données par celles du fichier sélectionné ?',

	// copy move dialog
	copy: 'Copier',
	move: 'Déplacer',
	copyOrMove: 'Copier ou déplacer : ',
	copyOnly: 'Copier ',
	createShortcut: 'Créer un raccourci',
	createShortcutDialogTitle: 'Création de raccourci : ',

	// External asset types
	wsProject: 'Projet Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Pack',
	dataModule: 'Module de données',
	exploration: 'Exploration',
	mode: 'Mode',
	live: 'En direct',
	snapshot: 'Instantané',
	noSnapshotsFound: 'Aucun instantané n\'a été trouvé',
	uploadedFile: 'Fichier transféré',
	fileUpload: 'Transférer les données',
	dataSetEx: 'Ensemble de données',
	externalRepository: 'Référentiel externe',
	queryMode: 'Mode requête',
	queryModeCompatible: 'Compatible',
	queryModeDynamic: 'Dynamique',
	report: 'Rapport',
	activeReport: 'Rapport actif',
	query: 'Requête',
	analysis: 'Analyse',
	dashboard: 'Tableau de bord',
	dashboardTemplate: 'Modèle de tableau de bord',
	jupyterNotebook: 'Bloc-notes',
	wsNotebook: 'Bloc-notes Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Histoire',
	workspace: 'Espace de travail',
	pagelet: 'Page',
	content: 'Contenu',
	directory: 'Espaces-noms',
	dataSet: 'Ensemble de données',
	powerPlayCube: 'Cube PowerPlay',
	powerPlayReport: 'Rapport PowerPlay',
	powerPlay8Report: 'Rapport PowerPlay',
	powerPlay8ReportView: 'Vue de rapport PowerPlay',
	reportTemplate: 'Modèle de rapport',
	packageConfigurations: 'Configuration du pack',
	agent: 'Agent',
	agentDefinition: 'Définition d\'agent',
	agentDefinitionView: 'Vue d\'agent',
	dataMovementTask: 'Tâche de transfert des données',
	dataMovementTaskAlias: 'Alias de la tâche de transfert des données',
	document: 'Document',
	DocumentRetention: 'Propriétés du document',
	jobDefinition: 'Définition du travail',
	job: 'Travail',
	metricsDataSourceETLTask: 'Tâche ETL source des données d\'indicateurs',
	metricsExportTask: 'Tâche d\'exportation des indicateurs',
	metricsFileImportTask: 'Tâche d\'importation des fichiers d\'indicateurs',
	metricsMaintenanceTask: 'Tâche de maintenance des indicateurs',
	planningTask: 'Tâche de planification',
	shortcut: 'Raccourci',
	URL: 'URL',
	launchable: 'Lançable',
	dataSetFolder: 'Dossier d\'ensembles de données',
	ViewAccessibleLabel: 'Afficher %{label}',
	overrideReportOptions: 'Remplacer les options de rapport par défaut',
	formats: 'Formats',
	saveReport: 'Sauvegarder le rapport',
	promptForValues: 'Me demander',
	reportView: 'Vue du rapport',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Données Excel',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Détails',
	open: 'Ouvrir',
	created: 'Créé',
	modified: 'Modifié',
	owner: 'Propriétaire',
	dataSource: 'Source de données',
	share: 'Partager',
	addToFavorites: 'Ajouter aux favoris',
	properties: 'Propriétés',
	detailsEmptyStateBody: 'Sélectionner un élément pour afficher ses détails',
	editNameAndDescription: 'Editer le nom et la description',
	none: 'Aucun',

	//rename dialog
	nameInvalid: 'Le nom n\'est pas valide',
	namePlaceholder: 'Entrez un nom',
	description: 'Description',
	descriptionInvalid: 'La description ne doit pas dépasser 350 caractères.',
	descriptionPlaceholder: 'Entrez une description',
	errorMessageApostropheError: 'Entrez un nom de fichier qui ne contient pas les caractères \' et "',
	renameCollisionError: '%{name} existe déjà. Essayez un autre nom.',
	unknownRenameError: 'Le renommage de l\'élément a échoué. Pour obtenir de l\'aide supplémentaire, contactez votre administrateur.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Impossible d\'ouvrir le dossier indiqué.',

	//Upload
	uploadToFolder: "Transférer dans <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Transférer dans <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> et lancer %{launchAction}",
	quickUpload: "Transfert rapide",
	quickUploadAndLaunch: "Glissez-déposez les fichiers à transférer dans <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> et à ouvrir dans l'un des espaces suivants :",
	unsupportedFilesSingle: "%{files} n'a pas été transféré car il n'est pas valide pour la fonction Lancement rapide.",
	unsupportedFilesMultiple: "Les fichiers n'ont pas pu être transférés car tous les fichiers que vous sélectionnez doivent être valides pour utiliser le Lancement rapide.",
	unsupportedFilesSingleInvalid: "%{files} n'est pas valide.",
	unsupportedFilesMultipleInvalid: "%{files} ne sont pas valides.",
	supportedFileTypes: "Seuls les types de fichier suivants sont autorisés : %{extensions}.",
	uploadDragAndDrop: "Glisser-déposer",
	uploadDragAndDropMessage: "Glissez-déposez votre fichier ici pour le transférer dans <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Les critères de recherche \'%{searchTerm}\' ont été sauvegardés.',
	searchWasntSaved: 'Les critères de recherche \'%{searchTerm}\' n\'ont pas été sauvegardés.',
	searchSuggestions: 'Suggestions',
	savedSearch: 'Recherches sauvegardées',
	searchWasDeleted: 'Les critères de recherche \'%{searchTerm}\' ont été supprimés.',
	searchWasntDeleted: 'Les critères de recherche \'%{searchTerm}\' n\'ont pas été supprimés.',
	savedBarTitle: 'Rechercher dans Cognos Analytics',
	searchContentPageTitle: 'Rechercher',
	searchContentPageTitleLabel: 'Affichage des résultats de \'%{searchTerm}\'',
	showingSearchRsult: 'Affichage des éléments %{resultCount}',
	saveSearch: 'Sauvegarder la recherche',
	saveTenSearches: 'Vous pouvez sauvegarder 10 recherches.',
	deleteASearch: 'Supprimez-en une pour en sauvegarder une autre.',
	close: 'Fermer',

	//recent view
	recents: 'Récent',
	noAccessRecent: 'Pas d\'accès',
	noAccessRecentMsg: 'Vous n\'avez pas accès à cet actif. Il a peut-être été désactivé ou supprimé, ou vos droits ont peut-être été réduits. Vérifiez l\'état de l\'actif à son emplacement source prévu. Vous pouvez supprimer l\'actif de vos éléments récents en cliquant sur OK.',
	noAccessMsg: 'Vous n\'avez pas accès à cet actif. Il a peut-être été désactivé ou supprimé, ou vos droits ont peut-être été réduits.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} éléments sélectionnés',
	itemSelected: '%{nameOfSelection} élément sélectionné'

});